// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* --- MAT-TAB --- */
:host {
  width: inherit;
}

mat-tab-group {
  width: 100%;
  height: 100%;
}
:host ::ng-deep .mat-tab-label {
   height: auto;
   line-height: 36px;
   min-width: inherit;
   padding: 0 1em;
}
:host ::ng-deep .mat-tab-body-wrapper {
   flex: 1;
}
:host ::ng-deep .mat-tab-body-content {
   display: flex;
   flex-direction: column;
   padding: 0 0 1em 1em;
}

/* --- CSS THAT APPEARS IN ALL THREE MAT-TABS --- */

.section-header {
  border-bottom: 1px solid #eaeaea;
  color: #222;
  padding-bottom: 10px;
  margin: 30px 0 10px;
}

/* --- CSS UNDER 1st MAT-TAB (DETAILS) --- */

/* Description related */
.description {
  margin-right: 10px;
}


/* Properties related */
.properties {
  font-size: 13px;
  line-height: 16px;
  margin: 0;
  padding: 0;
}

:host dl.properties dt,
.description label {
   color: #777;
   display: block;
   margin: 20px 0 0;
   padding-bottom: 3px;
}

:host dl.properties dd {
   color: #444;
   margin: 0 0 20px;
   word-break: break-all;
}

:host input,
:host textarea {
   border: 1px solid #e5e5e5;
   border-radius: 2px;
   font-size: 13px;
   outline: none;
   padding: 3px 6px;
   resize: none;
   width: 100%;
}

/* Comments container related */
.comments-container {
  overflow-y: auto;
}

.no-comment {
  padding: 1em;
}

.comments-container ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

.comments-container li {
  margin-top: 1em;
}

.comment-item {
  line-height: 20px;
  margin-left: 48px;
  position: relative;
}

.comment-item .avatar {
  float: left;
  margin-left: -48px;
  margin-top: 3px;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  object-fit: cover;
}

.comment-item .time {
  color: #657786;
  font-size: 12px;
}

.comment-item .delete {
  color: #999;
  cursor: pointer;
  position: absolute;
  top: 0;
  right: 0;
  font-size: 20px;
  width: 20px;
  height: 20px;
  display: none;
}

.comment-item:hover .delete {
  display: block;
}

.editing .item-content, .textarea-content {
  display: none;
}
.editing .textarea-content {
  display: block;
}

.textarea-content {
  margin-top: 5px;
  margin-right: 10px;
}

.edit2, .delete2 {
  color: #999;
  vertical-align: middle;
  font-size: 16px;
  text-align: center;
  display: none;
  cursor: pointer;
}

.delete2:hover {
  color: #d32f2f;
}

.edit2:hover {
  color: #00bed6;
}

.comment-item:hover .delete2, .comment-item:hover .edit2  {
  display: table-cell;
}

.mat-button {
  min-width: 0px;
}

.mat-button.save {
  color: #00bed6;
}

.textarea-content div {
  text-align: right;
}

.btn-comment {
  position: absolute;
  top: 0;
  right: 0;
}

.item-content {
  word-wrap: break-word;
  white-space: pre-line;
}

.author-name {
  margin-right: 4em;
  word-wrap: break-word;
  white-space: pre-line;
}

/* Add comment related */
.add-comment {
  text-align: right;
  margin: 5px 10px 0 0;
}

.add-comment textarea {
  display: block;
}

.add-comment button {
  margin-top: .5em;
  padding: 1px 16px;
  line-height: initial;
  min-width: 64px;
}

/* --- CSS UNDER 3rd MAT-TAB (METADATA) --- */

/* Select types related */
.select-types {
  padding-bottom: 10px;
  margin: 30px 0 10px;
  width: 100%;
}

/* Save metadata related */
.save-metadata {
  margin-top: 20px;
  text-align: right;
  margin-right: 5px;
}

.save-button {
  line-height: 1.7;
  min-width: inherit;
  padding: 0 1em;
}

/* Form related */
.form {
  margin-right: 5px;
}

::ng-deep .mat-tab-group .mat-tab-labels {
  display: flex;
}

::ng-deep .mat-tab-group .mat-tab-label {
  flex: 1;
  min-width: auto;         
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 500;
}

::ng-deep .mat-tab-group .mat-tab-label-active {
  font-weight: 600;
}

 .cert-popup{
  height:100%;
  overflow-y:auto;
  padding:16px;
  font-size:13px;
  line-height:1.5;
  box-sizing:border-box;
}

.cert-title{
  font-size:16px;
  font-weight:600;
  margin-bottom:12px;
}

.cert-warning{
  display:flex;
  align-items:center;
  gap:8px;
  background:#f6f6f6;
  border-radius:6px;
  padding:8px 10px;
  margin-bottom:14px;
  font-size:13px;
}

.cert-warning mat-icon{
  font-size:18px;
  color:#f4b400;
}

.cert-section{
  margin:12px 0;
}

.section-title{
  font-size:13px;
  font-weight:600;
  margin-bottom:4px;
}

.cert-section p{
  margin:2px 0;
  color:#555;
  font-size:12.5px;
}

hr{
  border:none;
  border-top:1px solid #e5e5e5;
  margin:10px 0;
}
.acrobat-cert-panel {
  background: #ffffff;

  height: 100%;

  padding: 20px;

  overflow-y: auto;

  color: #222;
}

.signature-header {
  display: flex;
  align-items: flex-start;
  gap: 12px;

  margin-bottom: 24px;
}

.signature-icon {
  width: 28px;
  height: 28px;
  font-size: 28px;
}

.valid-icon {
  color: #43a047;
}

.invalid-icon {
  color: #e53935;
}

.signature-title {
  font-size: 15px;
  font-weight: 600;

  line-height: 1.5;

  word-break: break-word;
}

.signature-status {
  margin-left: 40px;
}

.status-title {
  font-size: 14px;
  font-weight: 600;

  margin-bottom: 18px;
}

.status-item {
  display: flex;
  align-items: flex-start;

  gap: 10px;

  margin-bottom: 16px;

  line-height: 1.5;

  font-size: 14px;
}

.mini-status-icon {
  width: 18px;
  height: 18px;
  font-size: 18px;

  margin-top: 1px;
}

.signature-details {
  margin-top: 28px;
}

.details-title {
  display: flex;
  align-items: center;

  gap: 6px;

  font-size: 14px;
  font-weight: 600;

  margin-bottom: 18px;
}

.detail-row {
  margin-left: 32px;

  margin-bottom: 14px;

  font-size: 14px;

  line-height: 1.5;
}

.detail-label {
  font-weight: 600;
}

.detail-value {
  color: #222;
}

.detail-link {
  color: #1565c0;

  text-decoration: underline;

  cursor: pointer;
}

.text-success {
  color: #43a047;
}

.text-warning {
  color: #fb8c00;
}
.text-danger {
  color: #e53935 !important;
}
.details-status-icon {
  width: 30px;
  height: 30px;
  font-size: 30px;
}`, "",{"version":3,"sources":["webpack://./src/app/dms/viewer-controller/viewer-info-panel/viewer-info-panel.component.css"],"names":[],"mappings":"AAAA,oBAAoB;AACpB;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;AACA;GACG,YAAY;GACZ,iBAAiB;GACjB,kBAAkB;GAClB,cAAc;AACjB;AACA;GACG,OAAO;AACV;AACA;GACG,aAAa;GACb,sBAAsB;GACtB,oBAAoB;AACvB;;AAEA,mDAAmD;;AAEnD;EACE,gCAAgC;EAChC,WAAW;EACX,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA,4CAA4C;;AAE5C,wBAAwB;AACxB;EACE,kBAAkB;AACpB;;;AAGA,uBAAuB;AACvB;EACE,eAAe;EACf,iBAAiB;EACjB,SAAS;EACT,UAAU;AACZ;;AAEA;;GAEG,WAAW;GACX,cAAc;GACd,gBAAgB;GAChB,mBAAmB;AACtB;;AAEA;GACG,WAAW;GACX,gBAAgB;GAChB,qBAAqB;AACxB;;AAEA;;GAEG,yBAAyB;GACzB,kBAAkB;GAClB,eAAe;GACf,aAAa;GACb,gBAAgB;GAChB,YAAY;GACZ,WAAW;AACd;;AAEA,+BAA+B;AAC/B;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;AACA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;AACV;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA,wBAAwB;AACxB;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;AACjB;;AAEA,6CAA6C;;AAE7C,yBAAyB;AACzB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;AACb;;AAEA,0BAA0B;AAC1B;EACE,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,OAAO;EACP,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;CAEC;EACC,WAAW;EACX,eAAe;EACf,YAAY;EACZ,cAAc;EACd,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,aAAa;AACf;AACA;EACE,mBAAmB;;EAEnB,YAAY;;EAEZ,aAAa;;EAEb,gBAAgB;;EAEhB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;;EAET,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;;EAEhB,gBAAgB;;EAEhB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;;EAEhB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;;EAEvB,SAAS;;EAET,mBAAmB;;EAEnB,gBAAgB;;EAEhB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;;EAEf,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;;EAEnB,QAAQ;;EAER,eAAe;EACf,gBAAgB;;EAEhB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;;EAEjB,mBAAmB;;EAEnB,eAAe;;EAEf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;;EAEd,0BAA0B;;EAE1B,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB","sourcesContent":["/* --- MAT-TAB --- */\n:host {\n  width: inherit;\n}\n\nmat-tab-group {\n  width: 100%;\n  height: 100%;\n}\n:host ::ng-deep .mat-tab-label {\n   height: auto;\n   line-height: 36px;\n   min-width: inherit;\n   padding: 0 1em;\n}\n:host ::ng-deep .mat-tab-body-wrapper {\n   flex: 1;\n}\n:host ::ng-deep .mat-tab-body-content {\n   display: flex;\n   flex-direction: column;\n   padding: 0 0 1em 1em;\n}\n\n/* --- CSS THAT APPEARS IN ALL THREE MAT-TABS --- */\n\n.section-header {\n  border-bottom: 1px solid #eaeaea;\n  color: #222;\n  padding-bottom: 10px;\n  margin: 30px 0 10px;\n}\n\n/* --- CSS UNDER 1st MAT-TAB (DETAILS) --- */\n\n/* Description related */\n.description {\n  margin-right: 10px;\n}\n\n\n/* Properties related */\n.properties {\n  font-size: 13px;\n  line-height: 16px;\n  margin: 0;\n  padding: 0;\n}\n\n:host dl.properties dt,\n.description label {\n   color: #777;\n   display: block;\n   margin: 20px 0 0;\n   padding-bottom: 3px;\n}\n\n:host dl.properties dd {\n   color: #444;\n   margin: 0 0 20px;\n   word-break: break-all;\n}\n\n:host input,\n:host textarea {\n   border: 1px solid #e5e5e5;\n   border-radius: 2px;\n   font-size: 13px;\n   outline: none;\n   padding: 3px 6px;\n   resize: none;\n   width: 100%;\n}\n\n/* Comments container related */\n.comments-container {\n  overflow-y: auto;\n}\n\n.no-comment {\n  padding: 1em;\n}\n\n.comments-container ul {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.comments-container li {\n  margin-top: 1em;\n}\n\n.comment-item {\n  line-height: 20px;\n  margin-left: 48px;\n  position: relative;\n}\n\n.comment-item .avatar {\n  float: left;\n  margin-left: -48px;\n  margin-top: 3px;\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  object-fit: cover;\n}\n\n.comment-item .time {\n  color: #657786;\n  font-size: 12px;\n}\n\n.comment-item .delete {\n  color: #999;\n  cursor: pointer;\n  position: absolute;\n  top: 0;\n  right: 0;\n  font-size: 20px;\n  width: 20px;\n  height: 20px;\n  display: none;\n}\n\n.comment-item:hover .delete {\n  display: block;\n}\n\n.editing .item-content, .textarea-content {\n  display: none;\n}\n.editing .textarea-content {\n  display: block;\n}\n\n.textarea-content {\n  margin-top: 5px;\n  margin-right: 10px;\n}\n\n.edit2, .delete2 {\n  color: #999;\n  vertical-align: middle;\n  font-size: 16px;\n  text-align: center;\n  display: none;\n  cursor: pointer;\n}\n\n.delete2:hover {\n  color: #d32f2f;\n}\n\n.edit2:hover {\n  color: #00bed6;\n}\n\n.comment-item:hover .delete2, .comment-item:hover .edit2  {\n  display: table-cell;\n}\n\n.mat-button {\n  min-width: 0px;\n}\n\n.mat-button.save {\n  color: #00bed6;\n}\n\n.textarea-content div {\n  text-align: right;\n}\n\n.btn-comment {\n  position: absolute;\n  top: 0;\n  right: 0;\n}\n\n.item-content {\n  word-wrap: break-word;\n  white-space: pre-line;\n}\n\n.author-name {\n  margin-right: 4em;\n  word-wrap: break-word;\n  white-space: pre-line;\n}\n\n/* Add comment related */\n.add-comment {\n  text-align: right;\n  margin: 5px 10px 0 0;\n}\n\n.add-comment textarea {\n  display: block;\n}\n\n.add-comment button {\n  margin-top: .5em;\n  padding: 1px 16px;\n  line-height: initial;\n  min-width: 64px;\n}\n\n/* --- CSS UNDER 3rd MAT-TAB (METADATA) --- */\n\n/* Select types related */\n.select-types {\n  padding-bottom: 10px;\n  margin: 30px 0 10px;\n  width: 100%;\n}\n\n/* Save metadata related */\n.save-metadata {\n  margin-top: 20px;\n  text-align: right;\n  margin-right: 5px;\n}\n\n.save-button {\n  line-height: 1.7;\n  min-width: inherit;\n  padding: 0 1em;\n}\n\n/* Form related */\n.form {\n  margin-right: 5px;\n}\n\n::ng-deep .mat-tab-group .mat-tab-labels {\n  display: flex;\n}\n\n::ng-deep .mat-tab-group .mat-tab-label {\n  flex: 1;\n  min-width: auto;         \n  height: 35px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n::ng-deep .mat-tab-group .mat-tab-label-active {\n  font-weight: 600;\n}\n\n .cert-popup{\n  height:100%;\n  overflow-y:auto;\n  padding:16px;\n  font-size:13px;\n  line-height:1.5;\n  box-sizing:border-box;\n}\n\n.cert-title{\n  font-size:16px;\n  font-weight:600;\n  margin-bottom:12px;\n}\n\n.cert-warning{\n  display:flex;\n  align-items:center;\n  gap:8px;\n  background:#f6f6f6;\n  border-radius:6px;\n  padding:8px 10px;\n  margin-bottom:14px;\n  font-size:13px;\n}\n\n.cert-warning mat-icon{\n  font-size:18px;\n  color:#f4b400;\n}\n\n.cert-section{\n  margin:12px 0;\n}\n\n.section-title{\n  font-size:13px;\n  font-weight:600;\n  margin-bottom:4px;\n}\n\n.cert-section p{\n  margin:2px 0;\n  color:#555;\n  font-size:12.5px;\n}\n\nhr{\n  border:none;\n  border-top:1px solid #e5e5e5;\n  margin:10px 0;\n}\n.acrobat-cert-panel {\n  background: #ffffff;\n\n  height: 100%;\n\n  padding: 20px;\n\n  overflow-y: auto;\n\n  color: #222;\n}\n\n.signature-header {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n\n  margin-bottom: 24px;\n}\n\n.signature-icon {\n  width: 28px;\n  height: 28px;\n  font-size: 28px;\n}\n\n.valid-icon {\n  color: #43a047;\n}\n\n.invalid-icon {\n  color: #e53935;\n}\n\n.signature-title {\n  font-size: 15px;\n  font-weight: 600;\n\n  line-height: 1.5;\n\n  word-break: break-word;\n}\n\n.signature-status {\n  margin-left: 40px;\n}\n\n.status-title {\n  font-size: 14px;\n  font-weight: 600;\n\n  margin-bottom: 18px;\n}\n\n.status-item {\n  display: flex;\n  align-items: flex-start;\n\n  gap: 10px;\n\n  margin-bottom: 16px;\n\n  line-height: 1.5;\n\n  font-size: 14px;\n}\n\n.mini-status-icon {\n  width: 18px;\n  height: 18px;\n  font-size: 18px;\n\n  margin-top: 1px;\n}\n\n.signature-details {\n  margin-top: 28px;\n}\n\n.details-title {\n  display: flex;\n  align-items: center;\n\n  gap: 6px;\n\n  font-size: 14px;\n  font-weight: 600;\n\n  margin-bottom: 18px;\n}\n\n.detail-row {\n  margin-left: 32px;\n\n  margin-bottom: 14px;\n\n  font-size: 14px;\n\n  line-height: 1.5;\n}\n\n.detail-label {\n  font-weight: 600;\n}\n\n.detail-value {\n  color: #222;\n}\n\n.detail-link {\n  color: #1565c0;\n\n  text-decoration: underline;\n\n  cursor: pointer;\n}\n\n.text-success {\n  color: #43a047;\n}\n\n.text-warning {\n  color: #fb8c00;\n}\n.text-danger {\n  color: #e53935 !important;\n}\n.details-status-icon {\n  width: 30px;\n  height: 30px;\n  font-size: 30px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
